import { render, staticRenderFns } from "./FormRadioSelect.vue?vue&type=template&id=660f405a"
import script from "./FormRadioSelect.vue?vue&type=script&lang=js"
export * from "./FormRadioSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports